"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var App_vue_1 = require("./App.vue");
(0, vue_1.createApp)(App_vue_1.default).mount('#app');
